import { render, staticRenderFns } from "./MarksEntryPrePrimICSERubricsWWS.vue?vue&type=template&id=4ba722cc&scoped=true&"
import script from "./MarksEntryPrePrimICSERubricsWWS.vue?vue&type=script&lang=js&"
export * from "./MarksEntryPrePrimICSERubricsWWS.vue?vue&type=script&lang=js&"
import style0 from "./MarksEntryPrePrimICSERubricsWWS.vue?vue&type=style&index=0&id=4ba722cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba722cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VCard,VCol,VDataTable,VRow,VSnackbar,VTextField})
